import { ReactComponent as LoadingCircleIcon } from "../../assets/icons/custom/loading-circle.svg";

const PrimaryButton = ({
  title,
  className,
  onClick,
  isLoading,
}: {
  title: string;
  className: string;
  onClick: () => void;
  isLoading: boolean;
}) => {
  return (
    <button
      className={`flex justify-center items-center w-200 py-14 bg-darwin-primary-500 text-neutral-0 text-16 font-700 rounded-8 ${className} ${
        isLoading ? "opacity-20" : ""
      }`}
      onClick={onClick}
    >
      {/* Headings/H2/Bold */}
      {isLoading ? (
        <LoadingCircleIcon className="h-24 w-24 text-neutral-0" />
      ) : (
        title
      )}
    </button>
  );
};

export default PrimaryButton;
